import React from 'react'

import { Link } from 'elements/text/Link'
import { Text } from 'elements/text/Text'
import { Alert, TAlertProps } from 'elements/ui/Alert'

import { newRoutes } from 'routes/constants'

export type TCommunityCheckExplanationProps = {
  shortText?: boolean
} & TAlertProps

/**
 * ### CommunityCheckExplanation ###
 */
export const CommunityCheckExplanation: TFCC<TCommunityCheckExplanationProps> = ({ shortText, ...otherProps }) => (
  <Alert hideCloseButton {...otherProps}>
    <Text>trans:community:community.status.check.explanation</Text>
    {!shortText && (
      <Link to={newRoutes.page('advice')} target="_blank" color="blue" underline hoverColor="darkBlue" reload>
        <Text>trans:community:community.status.check.link-to-advice</Text>
      </Link>
    )}
  </Alert>
)
